/*
function applyScript() {
setTimeout(function(){
// Get all elements with class ".bold_option_value"
var optionElements = document.querySelectorAll('.bold_option_value');
console.log("BOLD==>")
// Loop through each option element
optionElements.forEach(function(optionElement) {
// Check if the option has a swatch
var swatchElement = optionElement.querySelector('.bold_option_value_swatch span');
if (swatchElement) {

  // Check if the option already has a "hover_image" span
  var existingHoverImage = optionElement.querySelector('.hover_image');
  if (existingHoverImage) {
  // Remove the existing "hover_image" span
  existingHoverImage.remove();
  }
  // Create a new span element with class "hover_image"
  var new_bold_title = document.createElement('span');
  new_bold_title.classList.add('new_bold_title');
  var oldTitle = optionElement.querySelector(".bold_option_value_title").textContent;
  new_bold_title.prepend(oldTitle);
  // Append the "hover_image" span to the "bold_option_swatch_title" element
  var swatchTitleElement = optionElement.querySelector('.bold_option_value label');
  swatchTitleElement.append(new_bold_title);
}
});
},500)
}


function observeDOM() {
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
        applyScript();
        document.querySelectorAll(".bold_option_element input, .bold_option_element select").forEach(function(element) {
          element.addEventListener('change', function() {
          applyScript();
          
          })
        })
        observer.disconnect();
        break;
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function() {
  observeDOM();
});
*/

// added by Shop Circle (Armin)
document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    var optionsDiv = document.querySelector('.bold_options_loaded');
    if (optionsDiv && optionsDiv.children.length !== 0) {
      buttonRedirect();
      openForm();
      boldPopupInit();
      snapFileUploadToRadio();
      hidePrintingDetailsTitle();
    }
  });
});

/*
function openForm() {
  var hulkForm = document.querySelector('.hulk_form_overlay');
  var allCheckboxes = document.querySelectorAll('.bold_option_checkbox');
  allCheckboxes.forEach((checkbox) => {
    var title = checkbox.querySelector('.bold_option_title');
    if (title.innerText === '*WANT MORE CUSTOMIZATION?') {
      title.parentElement.querySelector('input[type="checkbox"]').onchange = () => {
        hulkForm.classList.toggle('visible');
      };
    }
    document.querySelector('.closeHulkForm').onclick = () => {
      hulkForm.classList.remove('visible');
    }
  })
}
*/
function addCloseButton() {
  if (!(document.querySelector('.closeBoldPopup'))) {
    var closeBoldPopup = document.createElement('div');
    closeBoldPopup.className = 'closeBoldPopup';
    var seeDetailsText = document.querySelector('.bold_option_displaytext.bold_popup p span');
    
    if (seeDetailsText) {
      seeDetailsText.appendChild(closeBoldPopup);
      
      // --- UPDATED CLICK EVENT BELOW ---
      closeBoldPopup.addEventListener('click', function(){
        var targetOption = document.querySelector('input[name*="See Details"]');
        if (targetOption) {
          targetOption.click();
        } else {
          console.error('Could not find the See Details checkbox to close the modal.');
        }
      });
      
    } else {
      console.error('Target element not found');
    }
  }
}

function boldPopupInit() {
  var boldDisplayText = document.querySelector('.bold_option_displaytext');
  if (boldDisplayText) {
    setTimeout(() => {
      var boldPopup = document.querySelector('.bold_option_displaytext.bold_option_hidden');
      console.log('boldPopup check:', boldPopup);
      
      // The Safety Check: Only run this if the element actually exists
      if (boldPopup) {
        boldPopup.classList.add('bold_popup');
        classObserver.observe(boldPopup, {
            attributes: true,
            attributeFilter: ['class']
        });
      }
    }, 500);
  }
}

var classObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (!(mutation.target.classList.contains('bold_option_hidden'))) {
      addCloseButton();
    }
  });
});
// added by Shop Circle (Armin)



// added by Shop Circle (Joseph)
function openForm() {
  var hulkForm = document.querySelector('.hulk_form_overlay');
  var allCheckboxes = document.querySelectorAll('.bold_option_radio');
  allCheckboxes.forEach((checkbox) => {
    var title = checkbox.querySelector('.bold_option_value_title');
    if (title.innerText === 'Start Inquiry') {
      title.parentElement.querySelector('input[type="radio"]').onclick = () => {
        hulkForm.classList.toggle('visible');
      };
    }
    document.querySelector('.closeHulkForm').onclick = () => {
      hulkForm.classList.remove('visible');
    }
  })
}
//added by Shop Circle (Joseph)


function snapFileUploadToRadio() {
  var uploadContainer = document.querySelector('.bold_option_uploadfile');
  
  // Updated with the exact working text string
  var targetRadio = document.querySelector('input[value="Create new plate (+$100 one-time fee)"]');
  
  if (uploadContainer && targetRadio) {
    var targetLabel = targetRadio.closest('label');
    if (targetLabel) {
      targetLabel.appendChild(uploadContainer);
    }
  }
}

function hidePrintingDetailsTitle() {
  // Find all option titles on the page
  var allTitles = document.querySelectorAll('.bold_option_title');
  
  // Loop through them to find the exact match
  allTitles.forEach(function(title) {
    if (title.innerText.trim() === '*PRINTING DETAILS') {
      title.style.display = 'none'; // Hides just this specific span
    }
  });
}



function openForm() {
  var allOptionTitles = document.querySelectorAll('.bold_option_value_title');
  var labelBtn = null;
  
  // Find the "Start Inquiry" button
  allOptionTitles.forEach(function(title) {
    if (title.innerText.trim() === 'Start Inquiry') {
      labelBtn = title.closest('label'); 
    }
  });
  
  if (labelBtn) {
    labelBtn.onclick = function(e) {
      e.preventDefault();
      
      // 1. Find the actual Hulk form anywhere on the page
      var actualForm = document.querySelector('.pxFormGenerator') || document.querySelector('[data-form-id]');
      
      if (actualForm) {
        var hulkFormOverlay = document.querySelector('.hulk_form_overlay');
        
        // 2. Build the popup container if it doesn't exist
        if (!hulkFormOverlay) {
          hulkFormOverlay = document.createElement('div');
          hulkFormOverlay.className = 'hulk_form_overlay';
          document.body.appendChild(hulkFormOverlay); 
          hulkFormOverlay.appendChild(actualForm);
        }

        // 3. Grab the close button, or create it if missing
        var closeBtn = document.querySelector('.closeHulkForm');
        if (!closeBtn) {
          closeBtn = document.createElement('div');
          closeBtn.className = 'closeHulkForm';
        }
        
        // 4. FORCE it into the white form container so CSS anchors it correctly
        if (closeBtn.parentElement !== actualForm) {
          actualForm.appendChild(closeBtn); 
        }
        
        // 5. Show the popup!
        hulkFormOverlay.classList.add('visible');
        
      } else {
        console.error("Could not find the Hulk form to move into the popup.");
      }
    };
  }

  // Handle Closing the Form (Clicking 'X' OR the dark background)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.closeHulkForm') || e.target.classList.contains('hulk_form_overlay')) {
      var activeHulkForm = document.querySelector('.hulk_form_overlay');
      if (activeHulkForm) {
        activeHulkForm.classList.remove('visible');
      }
    }
  });
}


// Automatically hijack the Hulk App Block and turn it into a popup overlay
document.addEventListener('DOMContentLoaded', function() {
  var wrapInterval = setInterval(function() {
    
    // 1. Search for the form generated by the official App Block
    var nativeForm = document.querySelector('.hulkapps-form, [data-form-id]');
    
    if (nativeForm) {
      // 2. Grab the outermost container Hulk uses
      var formContainer = nativeForm.closest('.shopify-app-block') || nativeForm;
      
      // 3. If it hasn't been wrapped yet, wrap it!
      if (!formContainer.parentElement.classList.contains('hulk_form_overlay')) {
        var overlay = document.createElement('div');
        overlay.className = 'hulk_form_overlay';
        
        formContainer.parentNode.insertBefore(overlay, formContainer);
        overlay.appendChild(formContainer);
      }
      
      // 4. Form is safely hidden in the popup. Stop watching the page.
      clearInterval(wrapInterval);
    }
  }, 200); // Checks every 200 milliseconds during page load
  
  // Failsafe: Stop checking after 10 seconds so it doesn't run forever
  setTimeout(function() { clearInterval(wrapInterval); }, 10000);
});


// Additional Customization on Pricing Table 
setInterval(function() {
  // Target all table cells
  const tableCells = document.querySelectorAll('td');
  
  tableCells.forEach(function(cell) {
    // .innerText ignores hidden HTML tags, and regex normalizes all weird spaces
    let cleanText = cell.innerText.replace(/\s+/g, ' ').trim();
    
    if (cleanText === 'Buy 1') {
      cell.innerText = 'Buy 1 - 9';
    } else if (cleanText === 'Buy 10') {
      cell.innerText = 'Buy 10+';
    }
  });
}, 400);